/*
 * A one-time inline prompt, after the first agent turn of the session, to
 * turn on desktop alerts. Answering either way stores the choice; it never
 * comes back on this browser.
 */
import { BellRing } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import {
  markAlertsPrompted,
  requestDesktopAlerts,
  useAlertPrefs
} from "../alertPrefs";

export const EnableAlertsPrompt: FC<{ className?: string }> = ({
  className
}) => {
  const prefs = useAlertPrefs();
  if (prefs.prompted || !prefs.turnSent || prefs.permission !== "default")
    return null;

  return (
    <div
      data-testid="enable-alerts-prompt"
      className={cn(
        "flex items-center gap-2 rounded-lg border bg-fill-1 px-2.5 py-1.5 text-xs",
        className
      )}
    >
      <BellRing className="size-3.5 shrink-0 text-muted-foreground" />
      <span className="min-w-0 flex-1 text-fg">
        Get a desktop alert when an agent finishes or needs you
      </span>
      <Button
        size="sm"
        variant="ghost"
        className="h-6 px-2 text-xs text-muted-foreground"
        onClick={markAlertsPrompted}
      >
        Not Now
      </Button>
      <Button
        variant="primary"
        size="sm"
        className="h-6 px-2 text-xs"
        onClick={() => {
          markAlertsPrompted();
          void requestDesktopAlerts();
        }}
      >
        Turn on
      </Button>
    </div>
  );
};
